import React, {createContext, useReducer} from "react";
import {InductOverviewReducer} from  "../reducers/InductOverviewReducer";

export const InductOverviewContext = createContext();

const InductOverviewContextProvider = (props) => {
    const inductOverview = {
        pending_depart_from_upstream: '',
        pending_depart_from_upstream_unplanned: '',
        in_transit_from_upstream: '',
        in_transit_from_upstream_unplanned: '',
        pending_induct: '',
        pending_induct_unplanned: '',
        pending_re_induct: '',
        pending_re_induct_unplanned: '',
        inducted: '',
        stowed: '',
        sidelined: '',
        problem_solve: '',
        planned_cycle_volume: '-',
        planned_inducted: '-',
        unplanned_inducted: '-',
        total_inducted_actual: '-',
    }
    const [viewModel, dispatch ] = useReducer(InductOverviewReducer, inductOverview)
    return (
        <InductOverviewContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </InductOverviewContext.Provider>
    )
}

export default InductOverviewContextProvider


// WEBPACK FOOTER //
// ./src/components/induct/context/InductOverviewContext.js